import { Typography, Stack } from '@mui/material';
import type { ResourceIdentifiers } from '@repo/api-gw-sdk';

import { OverflowTooltip } from '../tooltips/overflowTooltip';

export const ResourceIdentifierItem = ({
  resource,
}: {
  resource: ResourceIdentifiers;
}) => {
  return (
    <Stack gap='4px' width='100%' className='truncate'>
      <OverflowTooltip
        shouldCloseOnScroll={true}
        text={resource.providerId}
        renderContent={(text, ref) => (
          <Typography variant='subtitle1' className='truncate' ref={ref}>
            {text}
          </Typography>
        )}
      />
      <Typography
        color={!resource.id ? 'var(--mui-palette-info-main)' : undefined}
        variant='body2'
        className='truncate'
      >
        {resource.name}
      </Typography>
    </Stack>
  );
};
